import { render, staticRenderFns } from "./CompanyCategorySelector.vue?vue&type=template&id=8144b3c4&scoped=true"
import script from "./CompanyCategorySelector.vue?vue&type=script&lang=js"
export * from "./CompanyCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanyCategorySelector.vue?vue&type=style&index=0&id=8144b3c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8144b3c4",
  null
  
)

export default component.exports